import customDirectiveParser from './customDirectiveParser';

export default (directiveNodeDef, directiveArguments) => {
  const customParser = customDirectiveParser(directiveNodeDef, directiveArguments);
  if (customParser) return customParser;
  return null;
};
